export default ["top", "right", "bottom", "left"];
